import { Component, Input } from '@angular/core';

/**
 * Generated class for the DeviationCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'deviation-card',
  templateUrl: 'deviation-card.html'
})
export class DeviationCardComponent {

  text: string;
  @Input('deviation') deviation: any;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/deviation-card/deviation-card.ts